import clsx from 'clsx'
import { useCompanies } from 'components/QuestionnaireRequestAutomated/hooks/useCompanies'
import useRequesterContext from 'components/QuestionnaireRequestAutomated/hooks/useRequesterContext'
import { Autocomplete } from 'components/utility/autocomplete'
import React, { useEffect, useMemo, useState } from 'react'
import PricingNote from '../Components/pricingNote'
import { GENERIC_QUESTIONNAIRE_KEY } from '..'

const InstructionSteps = [
  '1. Choose Questionnaire type.',
  '2. Preview and select form.',
  '3. Submit request now, pay later!',
]

const MetaDataQuestionnaireTypes = {
  lender: {
    label: 'find lender',
    placeHolder: 'search lenders',
  },
  attorney: {
    label: 'find legal provider',
    placeHolder: 'search attorneys + firms',
  },
  appraiser: {
    label: 'find appraisal firm or contact',
    placeHolder: 'search appraisers + firms',
  },
  other: {
    label: 'select existing providers',
    placeHolder: 'search providers',
  },
}

function CompanySelect({ onSelect, onCreate, questionnaireType }) {
  const [searchValue, setSearchValue] = useState('')
  const { data } = useCompanies(searchValue, questionnaireType?.key)

  const handleSelect = (company) => {
    onSelect(company)
    setSearchValue(company.name)
  }

  const handleCreateNewCompany = () => {
    onCreate({ name: searchValue, new: true }, questionnaireType)
  }

  const displayAddingNewCompany = useMemo(() => {
    return !data.some((item) => item.name.toLowerCase() === searchValue.toLowerCase())
  }, [data, searchValue])

  return (
    <Autocomplete
      disableFilter={true}
      options={data}
      labelKey="name"
      searchable={true}
      onSelect={handleSelect}
      getValueLabel={() => searchValue}
      onInputChange={(e) => setSearchValue(e.target.value)}
      placeholder={MetaDataQuestionnaireTypes[questionnaireType?.key]?.placeHolder}
      endIcon={<></>}
      getTopOptionListItem={
        searchValue &&
        displayAddingNewCompany && (
          <span onClick={handleCreateNewCompany} className="dome-p1 dome-color-aqua dome-text-w500">
            continue with {`${searchValue} >`}
          </span>
        )
      }
    />
  )
}

export default function CompanySelection({ org, companyTypes, onSubmit, onCreate }) {
  const { company, setCompany } = useRequesterContext()
  const [questionnaireType, setQuestionnaireType] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = () => {
    if (loading) return
    setLoading(true)
    onSubmit(company, questionnaireType).finally(() => setLoading(false))
  }

  useEffect(() => {
    setQuestionnaireType(null)
    setCompany(null)
    setLoading(false)
  }, [])

  const isStandardQuestionnaireType = questionnaireType?.key === GENERIC_QUESTIONNAIRE_KEY
  const disableButton = !isStandardQuestionnaireType && !company

  // TODO: Display pricing estimation
  const displayPricingNote = false
  // const displayPricingNote = company || isStandardQuestionnaireType

  const displayLenderSelection = questionnaireType && !isStandardQuestionnaireType

  return (
    <div className="company-selection">
      {!questionnaireType && (
        <div className="company-selection-note dome-d-flex dome-flex-column">
          <p className="dome-p2 dome-color-dark-grey">Request a completed Questionnaire by {org?.name}</p>
          <ul className="company-selection-note-list dome-color-dark-grey">
            {InstructionSteps.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ul>
        </div>
      )}
      <div style={{ marginTop: '4.8rem' }} className="dome-d-flex dome-flex-column dome-gap12">
        <p className="company-selection-label h4 dome-color-dark-grey">select questionnaire type</p>
        <Autocomplete
          labelKey="name"
          placeholder="select your type"
          options={companyTypes}
          onSelect={setQuestionnaireType}
        />
      </div>
      {displayLenderSelection && (
        <div style={{ marginTop: '4.8rem' }} className="dome-d-flex dome-flex-column dome-gap12">
          <p className="company-selection-label h4 dome-color-dark-grey">
            {MetaDataQuestionnaireTypes[questionnaireType?.key]?.label}
          </p>
          <CompanySelect onCreate={onCreate} onSelect={setCompany} questionnaireType={questionnaireType} />
        </div>
      )}
      {displayPricingNote && <PricingNote style={{ marginTop: '1.2rem' }} />}
      <div className="company-selection-navigation">
        <button
          type="button"
          disabled={disableButton}
          onClick={handleSubmit}
          className={clsx('dome-btn dome-btn-base', disableButton ? ' dome-btn-disabled' : 'dome-btn-dark-green')}
        >
          {loading ? <i className="fa-duotone fa-spinner fa-spin-pulse"></i> : 'Next'}
        </button>
      </div>
    </div>
  )
}
